






































































import EditPaymentMethodModal from "./EditPaymentMethodModal.vue";
import Vue from "vue";

interface State {
  dialog: boolean;
}

export default Vue.extend({
  name: "PaymentMethod",
  components: { EditPaymentMethodModal },
  props: ["paymentMethod", "customer", "failedInvoices", "organization"],
  data(): State {
    return {
      dialog: false
    };
  },
  methods: {
    getMonth(month: any) {
      const months = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      return months[month].substring(0, 3);
    }
  },
  computed: {
    totalUnpaid(): string | null {
      const total = this.failedInvoices
        ? this.failedInvoices.reduce((acc: any, cur: any) => {
            acc += cur.total;
            return acc;
          }, 0)
        : 0;

      if (total == 0) {
        return null;
      } else {
        return `$${(total / 100).toFixed(2)} Pending`;
      }
    }
  }
});
